// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","menu":"Header_menu__Y5boZ","menu-icon":"Header_menu-icon__24_8Z","title":"Header_title__17EAQ","form":"Header_form__1B5Js"};